import { useId } from "react";
import { CalcIcon } from "./CalcIcon";
import "./calculadora.css";

// Só aparece com 2+ arquivos importados. Cada botão é um cálculo completo e
// independente (tempo, filamentos, preço...); a tela abaixo mostra o do ativo.
export function AbasArquivos({ itens, ativoId, nome, onNome,
  onSelecionar, onRemover, onAdicionar, ocupado = false }) {
  const campoId = useId();
  return (
    <section className="calc-file-tabs" aria-label="Arquivos importados">
      <div className="calc-file-tabs-head">
        <strong>{itens.length} arquivos</strong>
        <span className="calc-field-help">Cada arquivo tem o próprio cálculo e preço. Escolha um para ver ou mudar.</span>
      </div>
      <ul className="calc-file-tab-list" aria-label="Escolher arquivo">
        {itens.map((item, i) => {
          const ativo = item.id === ativoId;
          return (
            <li key={item.id} className={"calc-file-tab" + (ativo ? " is-active" : "")}>
              <button type="button" aria-pressed={ativo} className="calc-file-tab-main"
                disabled={ocupado} onClick={() => onSelecionar(item.id)}>
                {item.thumbnail
                  ? <img src={item.thumbnail} alt="" />
                  : <span className="calc-file-tab-num" aria-hidden="true">{i + 1}</span>}
                <span className="calc-file-tab-text">
                  <span className="calc-file-tab-name">{item.nome}</span>
                  {item.detalhe && <small>{item.detalhe}</small>}
                </span>
              </button>
              <button type="button" className="calc-file-tab-remove" disabled={ocupado}
                aria-label={`Remover ${item.nome}`} title="Remover este arquivo" onClick={() => onRemover(item.id)}>
                <CalcIcon name="trash" size={16} />
              </button>
            </li>
          );
        })}
        <li className="calc-file-tab-add-item">
          <button type="button" className="calc-file-tab-add" disabled={ocupado} onClick={onAdicionar}>
            <CalcIcon name="plus" size={16} /> Arquivo
          </button>
        </li>
      </ul>
      {/* "Peças por impressão" mora na própria calculadora, logo abaixo do
          tempo — mesmo estado, então ter os dois campos na tela ao mesmo
          tempo só confundia. Aqui fica só o nome do item ativo. */}
      <div className="calc-file-fields calc-file-fields-single">
        <label htmlFor={campoId + "-nome"}>Nome deste item
          <input id={campoId + "-nome"} className="calc-input" value={nome} onChange={e => onNome(e.target.value)} placeholder="Ex.: Dragão P" />
        </label>
      </div>
    </section>
  );
}
